<template>
    <div class="location-content">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('locations.title')}}
                <hr>
            </span>
        </h1>
        <!-- Location -->
        <div class="row">
            <p v-html="$t('locations.introText')"></p>
        </div>

        <div class="row loc-row">
            <ul class="loc-list">
                <li v-for="(item,index) in locList[$i18n.locale]" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <h1>{{item.title}}</h1>
                    <p>{{item.address}}</p>
                    <p v-html="item.tel"></p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                locList:{
                    EN:[
                        {
                            imgUrl:require('../../assets/images/cali.png'),
                            title:"California, US",
                            address:"15495 Sand Canyon Rd, Suite 350,Irvine, CA 92618",
                            tel:"+(1) 949-681-2900<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/China.png'),
                            title:"Kunshan, China",
                            address:"No.269, 2nd Road, Export Processing Zone, Changjiang South Road, Kunshan City, Jiangsu Province, China 215300",
                            tel:"+(86) 512 5736-7777<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/taipei.png'),
                            title:"Taipei",
                            address:"5F., Building A, No. 209, Sec. 1, Nangang Rd., Nangang Dist., Taipei City, Taiwan, R.O.C. 11568",
                            tel:"+(886) 2 2785-7888<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/vietnam.png'),
                            title:"Bac Ninh, Vietnam",
                            address:"Que Vo Industrial Zone, Van Duong, Bac Ninh City, Bac Ninh Province, Vietnam 528308",
                            tel:"+(84) 241 363-4999<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/jerpan.png'),
                            title:"Kyoto, Japan",
                            address:"4992,Zaimoku-cho,Higashinotouin-higashiiru,Shichijodouri, Shimogyo-ku, Kyoto, Japan 600-8416",
                            tel:"+(81) 75-634-6312<br/><br/>"
                        }
                    ],
                    CN:[
                        {
                            imgUrl:require('../../assets/images/cali.png'),
                            title:"美国加利福尼亚州",
                            address:"15495 Sand Canyon Rd, Suite 350,Irvine, CA 92618",
                            tel:"+(1) 949-681-2900<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/China.png'),
                            title:"中国 昆山市",
                            address:"215300 中国江苏省昆山市长江南路出口加工区第二大道269号",
                            tel:"+(86) 512 5736-7777<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/taipei.png'),
                            title:"台北市",
                            address:"11568 台北市南港区南港路一段 209 号 A 栋 5 楼",
                            tel:"+(886) 2 2785-7888<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/vietnam.png'),
                            title:"越南北宁",
                            address:"Que Vo Industrial Zone, Van Duong, Bac Ninh City, Bac Ninh Province, Vietnam 528308",
                            tel:"+(84) 241 363-4999<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/jerpan.png'),
                            title:"日本京都",
                            address:"4992,Zaimoku-cho,Higashinotouin-higashiiru,Shichijodouri, Shimogyo-ku, Kyoto, Japan 600-8416",
                            tel:"+(81) 75-634-6312<br/><br/>"
                        }
                    ],
                    CHT:[
                        {
                            imgUrl:require('../../assets/images/cali.png'),
                            title:"美國加利福尼亞州",
                            address:"15495 Sand Canyon Rd, Suite 350,Irvine, CA 92618",
                            tel:"+(1) 949-681-2900<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/China.png'),
                            title:"中國 昆山市",
                            address:"215300 中國江蘇省昆山市長江南路出口加工區第二大道269號",
                            tel:"+(86) 512 5736-7777<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/taipei.png'),
                            title:"臺北市",
                            address:"11568 臺北市南港區南港路一段 209 號 A 棟 5 樓",
                            tel:"+(886) 2 2785-7888<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/vietnam.png'),
                            title:"越南北寧",
                            address:"Que Vo Industrial Zone, Van Duong, Bac Ninh City, Bac Ninh Province, Vietnam 528308",
                            tel:"+(84) 241 363-4999<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/jerpan.png'),
                            title:"日本京都",
                            address:"4992,Zaimoku-cho,Higashinotouin-higashiiru,Shichijodouri, Shimogyo-ku, Kyoto, Japan 600-8416",
                            tel:"+(81) 75-634-6312<br/><br/>"
                        }
                    ],
                    JP:[
                        {
                            imgUrl:require('../../assets/images/cali.png'),
                            title:"米國・カルフォルニア",
                            address:"5495 Sand Canyon Rd, Suite 350,Irvine, CA 92618",
                            tel:"＋(1)949-681-2900<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/China.png'),
                            title:"中國・昆山市",
                            address:"〒215300 中國江蘇省昆山市総合保稅區第二大道269號",
                            tel:"＋(86)512 5736-7777<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/taipei.png'),
                            title:"臺灣",
                            address:"〒11568 臺北市南港區南港路一段209號A棟5F",
                            tel:"＋(886)2 2785-7888<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/vietnam.png'),
                            title:"ベトナム・バクニン",
                            address:"Que Vo Industrial Zone, Van Duong, Bac Ninh City, Bac Ninh Province, Vietnam 528308",
                            tel:"＋(84)241 363-4999<br/><br/>"
                        },{
                            imgUrl:require('../../assets/images/jerpan.png'),
                            title:"日本・京都",
                            address:"〒600-8416 京都府下京區七條通東洞院東入材木町4992",
                            tel:"＋(81)75-634-6312<br/><br/>"
                        }
                    ]
                }
            }
        }
    }
</script>

<style scoped>
    .loc-list{
        overflow: hidden;
    }
    .loc-list li{
        float:left;
        width:50%;
        padding:0 2rem;
    }
    .loc-list li img{
        max-width: 100%;
        height: auto;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .15);
        max-height: 38.2rem;
    }
    .loc-list li h1{
        font-size: 1.6rem;
        font-weight: 700;
        margin:2rem 0;
    }
    .loc-list li p {
        margin-bottom: 2rem;
        font-size: 1.4rem;
        line-height: 1.8rem;
        height:5.4rem;
    }
    @media (max-width: 767px){
        .loc-list li{
            float:initial;
            width:auto;
            padding:0 1rem;
        }
        .loc-list li h1{
            font-size: .8rem;
            margin:1rem 0;
        }
        .loc-list li p {
            margin-bottom: 1rem;
            font-size: .7rem;
            line-height: 1rem;
            height:auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/ContactUs/Locations.vue